import { captureException } from '@platform/observability';
import { router } from './router';

/**
 * Loads a route's code chunk ahead of navigating there. Not `preloadRoute`: that also stages route
 * matches, and the router evicts cached matches of loader-less routes on the next commit
 * (`clearExpiredCache`), so it warmed nothing and console.errored the vanished match instead
 * (router-core 1.168.x). A failed chunk import is swallowed by `lazyRouteComponent` and recovered by
 * `bootstrapPreloadErrorReload`, so the catch only ever sees an unexpected router failure.
 */
export function warmRoute(id: string): void {
  const route = router.looseRoutesById[id];
  if (route) {
    router.loadRouteChunk(route)?.catch(captureException);
  }
}
